const Builder = require('../BuilderBase');
//doesn't load, due to recursion?
//const filters = require('.');

const createBasicFilter = filterName => {
    return class BasicFilter extends Builder {
        constructor(properties) {
            super(`filter_${filterName}`, '', properties);
        }
    };
};

const filters = {
    AlsoSearchWithAscii: createBasicFilter('AlsoSearchWithAscii'),
    ByNavigationSelection: createBasicFilter('ByNavigationSelection'),
    ByNavigationSelectionCriteria: createBasicFilter('ByNavigationSelectionCriteria'),
    ByNavigationSelectionDropdownCriteria: createBasicFilter('ByNavigationSelectionDropdownCriteria'),
    PropertiesToSearch: createBasicFilter('PropertiesToSearch'),
    OrderBy: createBasicFilter('OrderBy'),
    ForeignRelationSelectionOnForm: createBasicFilter('ForeignRelationSelectionOnForm'),
    ForeignRelationActiveRecord: createBasicFilter('ForeignRelationActiveRecord'),
    DefaultToPreviousSelection: createBasicFilter('DefaultToPreviousSelection'),
    DefaultValue: createBasicFilter('DefaultValue')
    //NestedListEntry: can't. won't work due to recursion
};

module.exports = class NestedListEntry extends Builder {
    constructor(properties) {
        super('filter_NestedListEntry', '', properties);
    }

    filter(type, properties) {
        const Filter = filters[type];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }
};
